/* eslint-disable no-inline-comments */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'

import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import { GREY, RED, LIGHTBLUE, LIGHTGREY } from '../../utils/color_utils'
import {
  SHOW_TOAST,
  STORE_SUBCOMPETENCYID,
  APP_TYPE
} from '../../store/actions/types'
import CompSelect from '../../components/categories/compSelect'
import SubCompSelect from '../../components/categories/subcompSelect'
import CategoryTabs from './CategoryTabs'
import { storeSubCompetency } from '../../store/actions/subcompActions'
import { showToast, clearStates } from '../../store/actions/toastAction'
import { VALUES_NAME } from '../../store/actions/types'
import AccountBalance from '@material-ui/icons/AccountBalanceOutlined'
import InfoIcon from '@material-ui/icons/InfoOutlined'

// TEMPORARY CONFIGURATION FLAG - not ready to deploy the tabs UI yet.
// Set to true to switch back to: tabs visible, dropdown collapsed behind
// the icon toggle by default (the normal/intended configuration once
// ready). Set to false (current) to show only the CompSelect/SubCompSelect
// dropdown tools, open by default, with CategoryTabs not rendered at all.
// This is the only thing that needs to change to flip between the two -
// nothing else in this file needs editing either way.
const SHOW_CATEGORY_TABS = true

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  titleColor: {
    color: `${LIGHTBLUE}`,
    fontSze: '1.25rem',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '500',
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
  },
  divStyle: {
    border: `1px solid ${LIGHTGREY}!important;`,
    margin: '0 14px',
    [theme.breakpoints.down('sm')]: {
      margin: '0 4px',
      padding: '0px 6px'
    }
  },
  dialogHeight: {
    maxHeight: `calc(100% - 20px)`
  },
  cats: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      flexWrap: 'nowrap'
    }
  },
  helpBox: {
    background: '#f9fafb',
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: 6,
    padding: '10px 12px',
    color: '#444',
    fontSize: 13,
    lineHeight: 1.4
  },
  note: {
    color: 'red',
    justifyContent: 'center',
    alignItems: 'center',
    fontSze: '1.25rem',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '500',
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
  },
  panel: {
    'marginBottom': '10px',
    'border': '1px solid rgba(0, 0, 0, 0.12)',
    'boxShadow': 'none',
    '&:hover': {
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 10px 0 rgba(0, 0, 0, 0.19)'
    }
  },
  // Collapsed toggle: no title text, no accordion row height - just the
  // icon itself, so the dropdown UI takes zero space until clicked.
  toggleButton: {
    padding: 4
  },
  dropdownPanel: {
    marginTop: 6
  }
})
class CategoriesSelect extends React.Component {
  constructor(props) {
    super(props)

  }

  state = {
    competency: '',
    competencyid: '',
    subcompetency: '',
    subcompetencyid: '',
    dailyThoughtType: this.props.dailyThoughtT,
    helpDialogOpen: false,
    // Dropdown UI (CompSelect/SubCompSelect) starts collapsed behind the
    // icon toggle (icon only, no space taken) ONLY when the tabs are the
    // primary UI (SHOW_CATEGORY_TABS true). While tabs are turned off,
    // there's no reason to hide the dropdown behind an icon - so it starts
    // open by default instead, same as it always did before the tabs work.
    dropdownPanelOpen: !SHOW_CATEGORY_TABS
  };

  componentWillMount() {
    if (this.props.competencyid) {
      this.setState({ competencyid: this.props.competencyid })
    }

    if (this.props.subcompetencyid) {
      this.setState({ subcompetencyid: this.props.subcompetencyid })
    }
  }

  componentDidMount() {
    if (this.props.competencyid) {
      this.setState({ competencyid: this.props.competencyid })
    }

    if (this.props.subcompetencyid) {
      this.setState({ subcompetencyid: this.props.subcompetencyid })
    }
  }

  handleCompetencyChange = (id, name) => {
    this.setState({ competencyid: id, competency: name })
    this.props.doCompState(name, id, 'competency')
  }

  handleSubCompetencyChange = (id, name) => {
    this.setState({ subcompetency: name })
    this.setState({ subcompetencyid: id })
    this.props.doCompState(name, id, 'subcompetency')
  }

  openHelpDialog = () => {
    this.setState({ helpDialogOpen: true })
  }

  closeHelpDialog = () => {
    this.setState({ helpDialogOpen: false })
  }

  // NEW: toggles the CompSelect/SubCompSelect dropdown panel open/closed.
  // CategoryTabs is unaffected by this - it always renders regardless of
  // whether the dropdown panel is open or collapsed.
  toggleDropdownPanel = () => {
    this.setState(prevState => ({ dropdownPanelOpen: !prevState.dropdownPanelOpen }))
  }

  render() {
    const { classes, opendialog, fullScreen } = this.props
    return (
      <div>
        <div style={{ width: '100%' }}>
          {this.props.pldp ?
            <ExpansionPanelDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <CompSelect
                    competencyid={this.state.competencyid}
                    pldp={this.props.pldp} handleCompetency={this.handleCompetencyChange.bind(this)}
                    companyID={this.props.companyID}
                    filterMode={this.props.filterMode}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SubCompSelect
                    subcompetencyid={this.state.subcompetencyid}
                    pldp={this.props.pldp}
                    handleSubCompetency={this.handleSubCompetencyChange.bind(this)}
                    competencyid={this.state.competencyid}
                  />
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
            : <div>
              {/* Collapsed by default: icon only, no title, no accordion row.
                  Clicking reveals the CompSelect/SubCompSelect dropdowns. */}
              <IconButton
                size='small'
                onClick={this.toggleDropdownPanel}
                aria-label='Toggle category dropdown selection'
                aria-expanded={this.state.dropdownPanelOpen}
                className={classes.toggleButton}
              >
                <AccountBalance style={{ color: '#ccbc74', fontSize: 22 }} />
              </IconButton>

              {/* IMPORTANT: always mounted, only visually hidden via CSS
                  when collapsed - NOT conditionally rendered/unmounted.
                  CompSelect -> CompetencyOptions and SubCompSelect ->
                  SubCompetencyOptions own the live Firebase listeners that
                  populate companyValues / subcompetencies_list, and
                  CategoryTabs relies on those listeners always running
                  (it never dispatches its own fetch). Unmounting these
                  when the panel is collapsed was what broke CategoryTabs
                  entirely - no fetch ever ran, so it had nothing to show. */}
              <div
                className={classes.dropdownPanel}
                style={{ display: this.state.dropdownPanelOpen ? 'block' : 'none' }}
                aria-hidden={!this.state.dropdownPanelOpen}
              >
                <div>
                  <Grid container spacing={2} alignItems='flex-start'>
                    <Grid item xs={12} sm={this.props.showSubcategoryHelp ? 8 : 12}>
                      <div className={classes.cats}>
                        <CompSelect
                          competencyid={this.state.competencyid}
                          handleCompetency={this.handleCompetencyChange.bind(this)}
                          companyID={this.props.companyID}
                          dailyThoughtType={this.state.dailyThoughtType}
                          filterMode={this.props.filterMode}
                        />
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <SubCompSelect
                            subcompetencyid={this.state.subcompetencyid}
                            handleSubCompetency={this.handleSubCompetencyChange.bind(this)}
                            competencyid={this.state.competencyid}
                          />
                          {this.props.showSubcategoryHelp ? (
                            <Hidden smUp>
                              <IconButton aria-label='Sub-category help' onClick={this.openHelpDialog} style={{ marginLeft: 6 }}>
                                <InfoIcon style={{ color: '#ccbc74' }} />
                              </IconButton>
                            </Hidden>
                          ) : null}
                        </div>
                      </div>
                    </Grid>
                    {this.props.showSubcategoryHelp ? (
                      <Hidden xsDown>
                        <Grid item xs={12} sm={4}>
                          <ExpansionPanel elevation={0} style={{ border: '1px solid rgba(0,0,0,0.12)' }}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls='subcat-help-content' id='subcat-help-header'>
                              <Typography variant='body2' style={{ fontWeight: 600 }}>How to choose a Sub Category</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                              <div className={classes.helpBox} aria-live='polite' style={{ width: '100%' }}>
                                <div><b>Leading self</b>: Do you have anything to contribute to this category that is related to self-improvement in this field, or knowledge unique to your own experience and what you learned for yourself and out of your own experience etc.</div>
                                <div style={{ height: 6 }} />
                                <div><b>Leading others</b>: Do you have anything to contribute to this category related to interacting, helping or guiding others pertinent to this field</div>
                                <div style={{ height: 6 }} />
                                <div><b>Leading org</b>: Any content you can lead with here that relates to building and helping any organization in this field</div>
                                <div style={{ height: 6 }} />
                                <div><b>Leading society</b>: Can you share something that will help people of this sector to contribute to society through this sector?</div>
                              </div>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        </Grid>
                      </Hidden>
                    ) : null}
                  </Grid>

                  {this.props.showSubcategoryHelp ? (
                    <Dialog open={this.state.helpDialogOpen} onClose={this.closeHelpDialog} fullWidth maxWidth='sm'>
                      <DialogTitle>Sub Category guide</DialogTitle>
                      <DialogContent>
                        <div style={{ color: '#444', fontSize: 14, lineHeight: 1.5 }}>
                          <div><b>Leading self</b>: Do you have anything to contribute to this category that is related to self-improvement in this field, or knowledge unique to your own experience and what you learned for yourself and out of your own experience etc.</div>
                          <div style={{ height: 10 }} />
                          <div><b>Leading others</b>: Do you have anything to contribute to this category related to interacting, helping or guiding others pertinent to this field</div>
                          <div style={{ height: 10 }} />
                          <div><b>Leading org</b>: Any content you can lead with here that relates to building and helping any organization in this field</div>
                          <div style={{ height: 10 }} />
                          <div><b>Leading society</b>: Can you share something that will help people of this sector to contribute to society through this sector?</div>
                        </div>
                      </DialogContent>
                    </Dialog>
                  ) : null}
                </div>
              </div>
            </div>}

        </div>

        {SHOW_CATEGORY_TABS ? (
          <CategoryTabs
            competencyid={this.state.competencyid}
            subcompetencyid={this.state.subcompetencyid}
            onSelectCompetency={this.handleCompetencyChange}
            onSelectSubcompetency={this.handleSubCompetencyChange}
          />
        ) : null}

      </div>
    )
  }
}

CategoriesSelect.propTypes = {
  pldp: PropTypes.bool
}

let CategoriesStyled = withStyles(styles)(CategoriesSelect)

const mapStateToProps = state => {
  return {
    subcompFilter: state.subcomp.cvalue, // subcategory id
    fscompname: state.scompname.scompname // subcategory name
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showToast: params => dispatch(showToast(params)),
    storeSubCompetency: params => dispatch(storeSubCompetency(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesStyled)